<template>
  <div class="input-box">
    <input
      :name="name"
      :type="type"
      class="field w-100 mt-6"
      :placeholder="placeholder"
    >
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GlobalInput',

  props: {
    type: {
      type: String,
      default: () => 'text'
    },

    placeholder: {
      type: String,
      default: () => 'text'
    },

    name: {
      type: String,
      default: () => 'text'
    }
  }
})
</script>

<style lang="scss" scoped>
  .input-box .field {
    height: 40px;
    padding: 0 15px;
    border-radius: 4px;
    color: rgb(var(--black1));
    border: 1px solid rgba(var(--gray2), .7);

    &::placeholder {
      color: rgb(var(--gray2));
    }
  }
</style>
